import { Component, OnInit, OnDestroy } from "@angular/core";

import { Observable, Subject } from "rxjs";
import { delay, filter, map } from "rxjs/operators";

import { AppserverInstallationCredentialsRepository } from "@e-forsyning/common/credentials";
import { RedirectService } from "@e-forsyning/common/router";

import { AppInfo } from "./app-info/app-info.model";
import { AppInfoService } from "./app-info/app-info.service";
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { Title } from "@angular/platform-browser";
import { AppShellComponent } from "@e-forsyning/common/app-shell";
import { EforsyningSidenavMenuComponent } from "@e-forsyning/common/eforsyning-menu";
import { AppVaelgInstallationComponent } from "./app-vaelg-installation/app-vaelg-installation.component";
import { AppInfoComponent } from "./app-info/app-info.component";
import { AsyncPipe } from "@angular/common";
import { NotificationPermissionRequestComponent } from "@e-forsyning/common/push-notification";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    imports: [
        AppShellComponent,
        EforsyningSidenavMenuComponent,
        AppVaelgInstallationComponent,
        AppInfoComponent,
        RouterOutlet,
        AsyncPipe,
        NotificationPermissionRequestComponent
    ]
})
export class AppComponent implements OnInit, OnDestroy {
    public erLoggetInd$: Observable<boolean>;
    public infos$: Observable<AppInfo[]>;
    public featureFlagEnabled: boolean = false;

    private readonly destroy$ = new Subject<void>();

    constructor(
        private readonly credentials: AppserverInstallationCredentialsRepository,
        private readonly appInfoService: AppInfoService,
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly title: Title,
        private readonly redirectService: RedirectService
    ) {}

    public ngOnInit(): void {
        this.erLoggetInd$ = this.credentials.valueChanges.pipe(
            delay(0) /* Lav fra Synkron til Asynkron for at undgå: ExpressionChangedAfterItHasBeenCheckedError */,
            map((credentials) => !!credentials.forsyningNodeId)
        );
        this.infos$ = this.appInfoService.getInfos().pipe(delay(0) /* Lav fra Synkron til Asynkron for at undgå: ExpressionChangedAfterItHasBeenCheckedError */);

        this.setPageTitle();
    }

    public setPageTitle() {
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                map(() => {
                    const child: ActivatedRoute | null = this.route.firstChild;
                    const documentid = this.router.url.split("/mine-dokumenter/").pop();
                    let title = child && child.snapshot.data["title"];
                    if (this.router.url.includes("/mine-dokumenter/") && documentid && title) {
                        return `${title} - ${documentid}`;
                    } else if (title) {
                        return title;
                    }
                })
            )
            .subscribe((title) => {
                if (title) {
                    this.title.setTitle(`${title} - E|Forsyning`);
                }
            });
    }

    public onInstallationerClick(): void {
        this.redirectService.redirectTilInstallationer();
    }

    public onCloseAppInfo(value: AppInfo): void {
        value.visible = false;
        this.appInfoService.onCloseAppInfo(value);
    }

    public ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
